import { render, staticRenderFns } from "./NewInsuranceCompany.vue?vue&type=template&id=69869348"
import script from "./NewInsuranceCompany.vue?vue&type=script&lang=js"
export * from "./NewInsuranceCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports